import { PostService } from '../../model/post.service';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import {
  FirebaseListObservable
} from 'angularfire2/database-deprecated';
import 'rxjs/add/operator/debounceTime';
import { TranslateService } from 'ng2-translate';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/toPromise';
import { UserService } from '../../_services/user.service';
import { ScrollService } from '../../_services/scroll.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from '../../_services/alert.service';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { MediaMatcher } from '@angular/cdk/layout';
import { SeoService } from '../../_services/seo.service';
import { SaveMessageComponent } from '../../directive/save-message/save-message.component';
import { MatDialog } from '@angular/material';
import { PhoneTakeRequestComponent } from '../../directive/phone-take-request/phone-take-request.component';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'user-home',
  templateUrl: './user-home.component.html',
  styleUrls: ['./user-home.component.css'],
  providers: [UserService, PostService]
})
export class UserHomeComponent implements OnInit {
  nearLocations: any[];
  searchTerm: any[];
  products: any[] = [];
  model: any[] = [];
  input: string;
  kk = 'product';
  link = 'iphone';
  product: any;
  activeId = 'ngb-tab-1';
  user: any;
  event = 0;
  key: any;
  searchData: any[] = [];
  whichPage = 'homepage';
  userId = localStorage.getItem('currentUserId');
  private subscription: Subscription = new Subscription();
  private sub = new Subscription();
  mobileQuery: any;
  visible: any;
  isMobile;
  private _mobileQueryListener: () => void;

  constructor(
    public translate: TranslateService,
    public modalService: NgbModal,
    private dialog: MatDialog,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private media: MediaMatcher,
    private scrollService: ScrollService,
    private afs: AngularFirestore,
    private userService: UserService,
    private cd: ChangeDetectorRef,
    private seo: SeoService,
    private alertService: AlertService
  ) {

    // title.setTitle('bigadvice - Zaman Tüneli');
    // meta.addTags([
    //   { name: 'description', content: 'How to use Angular 4 meta service' },
    //   { name: 'author', content: 'talkingdotnet' },
    //   { name: 'keywords', content: 'Angular, Meta Service' }
    // ]);
    this.seo.generateTags({
      title: 'Contact Page',
      description:
        'Contact me through this awesome search engine optimized Angular component',
      image: 'https://instafire-app.firebaseapp.com/assets/meerkat.jpeg',
      slug: 'contact-page'
    });
    this.userId = localStorage.getItem('currentUserId');
    translate.setDefaultLang('tr');

    this.mobileQuery = this.media.matchMedia('(max-width: 1024px)');
    this._mobileQueryListener = () => this.cd.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.isMobile = window.matchMedia('(max-width: 1024px)').matches;
  }

  ngOnInit() {




    this.subscription.add(
      this.subscription = this.userService.getUser().subscribe(user => {
        this.userId = localStorage.getItem('currentUserId');
        this.user = user;
      })
    );
    this.sub = this.scrollService.isScroll.subscribe(a => {
      if (document.querySelector(".perfect-scrollbar").scrollTop > 620) {
        this.visible = true;

      }
      else {
        this.visible = false;

      }
    })

    let message = this.activatedRoute.snapshot.queryParams['message'];

    if (message && message === 'landingMessage') {
      this.dialog.open(SaveMessageComponent, {
        width: '600px',
        data: {
          message: 'Aramıza hoşgeldin,iyi ki bizimlesin! birlikte güçlüyüz.',
          type: 'update'
        }
      });
    }
    // if (navigator.geolocation) {
    //   navigator.geolocation.getCurrentPosition(position => {
    //     this.foursquareService.foursquareGet(position.coords.latitude + ',' + position.coords.longitude)
    //       .subscribe(data => {
    //         this.nearLocations = data.response.venues;
    //       });
    //   }, error => {

    //   });
    // };
  }
  ngOnDestroy() {
    this.sub.unsubscribe();
    this.subscription.unsubscribe();
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  open(content, ctrl) {

    if (this.userId) {
      this.afs.collection('posts').ref.where('user', '==', this.userId).get().then(data => {
        const x = [];
        data.forEach(post => {
          if (post.data().modifyDate > Date.now() - 86400000) {
            x.push(post.data());
          }
        });
        if (x.length >= 10) {
          this.dialog.open(SaveMessageComponent, {
            width: '600px',
            data: {
              message: 'Günlük paylaşım hakkını doldurdun, ama biz seni dinlemeye doyamadık! Yarın yeni paylaşımların için bekliyoruz :)',
              type: "update"
            }
          });

        }
        else {

          this.modalService.open(content, { backdrop: "static" });
        }
      })

    } else {
      this.router.navigate(["/auth"]);
    }
  }
  requestPhone() {
    if (this.userId) {
      this.dialog.open(PhoneTakeRequestComponent, {
        width: 'auto',
        height: '80%',
        data: {
          title: 'Tebrikler!',
          type: 'badge',
          image: 'categoryIcons/' + 'category.uniqueName' + '.png',
          content: 'category.name' + ' kategorisinde uzmanlık kazandın.'
        }
      });
    } else {
      this.router.navigate(['/auth']);
    }
  }
  onTabChange($event) {


    this.activeId = $event.activeId;

    if (this.activeId === '0') {

      this.whichPage = 'banaozel';

    }
    else {
      this.whichPage = 'homepage';

    }
    this.cd.markForCheck();
  }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/pages/user-home/user-home.component.ts